import { SystemRestart } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconSystemRestart12Line = createIcon(SystemRestart, 12, "Line");
export const IconSystemRestart16Line = createIcon(SystemRestart, 16, "Line");
export const IconSystemRestart20Line = createIcon(SystemRestart, 20, "Line");
export const IconSystemRestart24Line = createIcon(SystemRestart, 24, "Line");
export const IconSystemRestart32Line = createIcon(SystemRestart, 32, "Line");
export const IconSystemRestart48Line = createIcon(SystemRestart, 48, "Line");
export const IconSystemRestart64Line = createIcon(SystemRestart, 64, "Line");
